import { render, staticRenderFns } from "./ucenterMenu.vue?vue&type=template&id=ac3eb690&scoped=true&"
import script from "./ucenterMenu.vue?vue&type=script&lang=js&"
export * from "./ucenterMenu.vue?vue&type=script&lang=js&"
import style0 from "./ucenterMenu.vue?vue&type=style&index=0&id=ac3eb690&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac3eb690",
  null
  
)

export default component.exports